import { render, staticRenderFns } from "./RecipeList.vue?vue&type=template&id=2251977c&scoped=true&"
import script from "./RecipeList.vue?vue&type=script&lang=js&"
export * from "./RecipeList.vue?vue&type=script&lang=js&"
import style0 from "./RecipeList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RecipeList.vue?vue&type=style&index=1&id=2251977c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2251977c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2251977c')) {
      api.createRecord('2251977c', component.options)
    } else {
      api.reload('2251977c', component.options)
    }
    module.hot.accept("./RecipeList.vue?vue&type=template&id=2251977c&scoped=true&", function () {
      api.rerender('2251977c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecipeList.vue"
export default component.exports